import React, { useEffect, useRef } from "react";

const CustomModal = ({ show, onHide, title, children, size = "md" }) => {
  // Modal body için ref oluştur
  const modalBodyRef = useRef(null);

  // Modal gösterildiğinde body scrollunu engelle
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";

      // Modal açıldığında, içeriğin en başına scroll yap
      if (modalBodyRef.current) {
        modalBodyRef.current.scrollTop = 0;
      }
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  // Modal gösterilmiyorsa hiçbir şey render etme
  if (!show) return null;

  // Modal boyutu için sınıf belirle
  const modalSizeClass = {
    sm: "modal-sm",
    md: "modal-md",
    lg: "modal-lg",
    xl: "modal-xl",
  };

  // Tıklama olayını modal içeriğine ulaşmasını engelle
  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  // ESC tuşunu dinle
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      onHide();
    }
  };

  // Viewport yüksekliğini hesapla (ekran yüksekliğinin %90'ı)
  const viewportHeight = window.innerHeight * 0.9;

  return (
    <div
      className="modal-overlay"
      onClick={onHide}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1050,
        overflowY: "auto",
        padding: "20px 0",
      }}
    >
      <div
        className={`modal-dialog ${modalSizeClass[size]}`}
        onClick={handleModalContentClick}
        style={{
          width: "100%",
          maxWidth:
            size === "sm"
              ? "300px"
              : size === "md"
              ? "500px"
              : size === "lg"
              ? "800px"
              : "1140px",
          margin: "0 auto",
          position: "relative",
          maxHeight: `${viewportHeight}px`,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="modal-content"
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "white",
            borderRadius: "0.3rem",
            boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
            outline: 0,
            maxHeight: `${viewportHeight}px`,
            overflow: "hidden",
          }}
        >
          <div
            className="modal-header"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "1rem",
              borderBottom: "1px solid #dee2e6",
              flexShrink: 0,
            }}
          >
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="close-button"
              onClick={onHide}
              style={{
                padding: "0.5rem",
                marginLeft: "auto",
                backgroundColor: "transparent",
                border: 0,
                fontSize: "1.5rem",
                fontWeight: 700,
                lineHeight: 1,
                color: "#000",
                cursor: "pointer",
                opacity: 0.5,
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            ref={modalBodyRef}
            className="modal-body"
            style={{
              position: "relative",
              flex: "1 1 auto",
              padding: "1rem",
              overflowY: "auto",
              maxHeight: `calc(${viewportHeight}px - 72px)`, // Başlık ve padding'i hesaba kat
            }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
